import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Form } from 'antd';
import { useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';
import { Link as RouterLink } from 'react-router-dom';
import * as Yup from 'yup';
import AntdCheckbox from '../../common/antd-form-components/AntdCheckbox';
import LoadingModal from '../../common/loading-modal/LoadingModal';
import routerLinks from '../../components/app/routerLinks';
import ForgetPasswordContext from '../../contexts/forget-password-context/ForgetPasswordContext';
import useFCMDeviceToken from '../../custom-hooks/useFCMDeviceToken';
import useSigninEmailPassword from '../../custom-hooks/useSigninEmailPassword';
import ForgetPasswordModal from './ForgetPasswordModal';
import './SigninForm.scss';

const SigninForm = () => {
  const { t, i18n } = useTranslation();
  const fcmDeviceToken = useFCMDeviceToken();
  const { forgetPasswordModalOpened } = useContext(ForgetPasswordContext);
  const generalLabelStr = (v) => t(`signup_form.${v}.label`);
  const generalrequiredErrStr = (v) => t(`signup_form.${v}.errors.required`);
  const generalEqualErrorStr = (v, equals) =>
    t(`signup_form.${v}.errors.equals`, {
      equals
    });

  const schema = Yup.object().shape({
    // loginKey: Yup.string().required(t('signin_form.login_key.errors.required')),
    // password: Yup.string().required(t('signin_form.password.errors.required'))
    phone: Yup.string()
      // .typeError(generalTypeErrorStr('phone'))
      .required(generalrequiredErrStr('phone'))
      // .matches(/^[0-9]+$/, generalTypeErrorStr('phone'))
      .test('phone', generalEqualErrorStr('phone', 10), (v) => {
        return v && String(v)?.length === 13;
      })
  });
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: {
      phone: '',
      remember: true
    }
  });

  const { signMeInWithEmailPassword, isLoadingSignin } =
    useSigninEmailPassword();
  const onSubmit = (data) => {
    const formatedIntlPhone = formatPhoneNumberIntl(`${data.phone}`); // '+966 50 123 4444'
    const phoneStrArr = formatedIntlPhone.split(' '); // ['+966', '50', '123', '4444']
    const countryCode = phoneStrArr[0];
    let phone = '';
    if (phoneStrArr?.length === 2) phone = phoneStrArr[1];
    else if (phoneStrArr?.length > 2) {
      let array = phoneStrArr.filter((item, index) => index > 0); // ['50', '123', '4444']
      phone = array.join('');
    }

    signMeInWithEmailPassword({
      phone,
      // countryCode,
      fire_base: fcmDeviceToken
    });
  };

  const [form] = Form.useForm();
  return (
    <>
      <Form
        className="signin-form custom-shared-form"
        form={form}
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
      >
        <div className="form-header">
          <p className="bold-font main-title">{t('signin_form.title')}</p>
          <p className="sub-title">{t('signin_form.sub_title')}</p>
        </div>

        <div className="form-body">
          <div
            className={`country-code-phone-wrap ${i18n.dir()}`}
            style={{
              marginBottom: 28
            }}
          >
            <p
              style={{
                paddingBottom: 8
              }}
            >
              {generalLabelStr('phone')}
            </p>
            <Controller
              name="phone"
              control={control}
              // render={({ field: { onChange, onBlur, value, name, ref } }) => {
              render={({ field }) => {
                return (
                  <PhoneInput
                    {...field}
                    placeholder={generalLabelStr('phone')}
                    // value={phoneValue}
                    // onChange={setPhoneValue}
                    defaultCountry="SA"
                    className={`custom-phone-input ${i18n.language}`}
                    countries={['SA']}
                    addInternationalOption={false}
                  />
                );
              }}
            />
            <p className="error-p">{errors?.phone?.message}</p>
          </div>

          {/* <RouterLink
            className="forget-p"
            // onClick={() => setForgetPasswordModalOpened(true)}
            to={routerLinks?.forgetPasswordRoute}
          >
            {t('signin_form.forget_pass')}
          </RouterLink> */}
          <AntdCheckbox
            name="remember"
            control={control}
            label={t('signup_form.remember_me')}
            errorMsg={errors?.remember?.message}
            validateStatus={errors?.remember ? 'error' : ''}
          />
          {/* <AntdCheckbox name="remember" label="تذكرنى" control={control} /> */}
          <Button
            className="submit-btn"
            htmlType="submit"
            type="primary"
            // icon={<LoginOutlined />}
            loading={isLoadingSignin}
          >
            {isLoadingSignin
              ? t('signin_form.submit_btn.loading')
              : t('signin_form.submit_btn.label')}
          </Button>
        </div>
        <div className="dont-have-account-text">
          <span>{t('signin_form.dont')}</span>{' '}
          <RouterLink to={routerLinks?.userSignupRoute}>
            {t('signin_form.new_account')}
          </RouterLink>
        </div>
      </Form>

      {forgetPasswordModalOpened && <ForgetPasswordModal />}
      {isLoadingSignin && <LoadingModal />}
    </>
  );
};

export default SigninForm;
